import SvgColor from "../../../src/components/ui/svg-color";
import { alpha } from "@mui/material/styles";
import PropTypes from "prop-types";
import Collapse from '@mui/material/Collapse';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import List from '@mui/material/List';
import * as React from 'react';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ConstructionIcon from '@mui/icons-material/Construction';
import {
  FaUsers,
  FaChartPie,
  FaFolderOpen,
  FaMoneyBill,
  FaChartLine,
  FaExclamationCircle,
  FaBook,
  FaHome,
  FaUserClock,
  FaListUl,
  FaUserEdit,
  FaMoneyCheck,
  FaMoneyCheckAlt,
  FaClipboardList,
  FaShoppingCart,
  FaChartBar,
  FaCommentDollar,
  FaBirthdayCake,
  FaSearch,
  FaTag,
  FaBox,
  FaFileSignature,
  FaTasks,
  FaPhone,
  FaCode,
  FaComments,
  FaCamera,
  FaGlobe,
  FaCalendarCheck,
  FaPoll,
  FaUser,
  FaWrench,
  FaAd,
  FaNetworkWired,
  FaWordpress,
  FaFilter,
  FaCalendar,
  FaBell,
  FaClock,
  FaPaintRoller,
  FaInfoCircle,
  FaTimesCircle,
  FaFileInvoiceDollar,
  FaUsersCog,
  FaFileAlt,
  FaCloud,
  FaPalette,
  FaEnvelope
} from "react-icons/fa";
import { FiShare2 } from "react-icons/fi";
import RouterLink from "../../routes/components/router-link";

import { MdCalendarMonth, MdCampaign, MdSchedule } from "react-icons/md";
// ----------------------------------------------------------------------
import { usePathname } from "../../routes/hooks";
import { GiReceiveMoney } from "react-icons/gi";
import { FaCalendarDays, FaMoneyBillTrendUp, FaRegCalendarDays, FaTicket } from "react-icons/fa6";
import { useState } from "react";

import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'; // Administrativo
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter'; // Comercial
import AssignmentIcon from '@mui/icons-material/Assignment'; // Proyectos
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'; // Contabilidad
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Tooltip from "../../components/ui/ToolTip";
import { canAccessPagosRecurrentes } from "../../utils/canAccessPagosRecurrentes";

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const NavConfig = ({ user, collapsed, upLg }) => {

  const notifications = useSelector((state) => state.notifications.count);

  const isTempWorker = (u) => u?.puesto?.toUpperCase().trim() === "TRABAJADOR TEMPORAL";
  const isSEOWorker = (u) => u?.puesto?.toUpperCase().trim() === "SEO";
  const isTempAudiovisual = (u) => isTempWorker(u) && u?.subarea?.toUpperCase().trim() === "AUDIOVISUALES";
  const isTempMarketing = (u) => isTempWorker(u) && ["SOCIAL MEDIA", "SMM"].includes(u?.subarea?.toUpperCase().trim());
  const isTempSeller = (u) => u?.area?.toUpperCase() === "COMERCIAL" && u?.puesto?.toUpperCase().trim() === "VENDEDOR TEMPORAL";
  
  const items = [
    {
      title: "Inicio",  
      path: "/home",
      icon: FaHome,
      category: null,
      show: true,
    },
    {
      title: "Asistencia",
      path: "/home/marcar-asistencia",
      icon: FaUserClock,
      category: null,
      show: true,
    },
    {
      title: "Bloques de trabajo",
      path: "/home/bloques-trabajo",
      icon: FaTasks,
      category: null,
      show: true
    },
    {
      title: "Correo",
      path: "/home/correo",
      icon: FaEnvelope,
      category: null,
      description: "Bandeja de correo electrónico multi-cuenta.",
      show: true
    },



    // Administrativo
    {
      title: "Horarios",
      path: "/home/horarios",
      icon: MdSchedule,
      category: "Administrativo",
      description: "Horarios de todos los trabajadores.",
      show: true
    },
    {
      title: "Usuarios de clientes",
      path: "/home/clientesUsuarios",
      icon: FaUsers,
      category: "Administrativo",
      description: "Lista de los usuarios de clientes registrados en el sistema.",
      show: user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Reporte diario",
      path: "/home/reporteDiario",
      category: "Administrativo",
      icon: FaFileSignature,
      description: "Registro de reporte diario de todos los trabajadores.",
      show: (
        user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI"
      )
    },
    {
      title: "Trabajadores",
      path: "/home/trabajadores",
      icon: FaUsers,
      category: "Administrativo",
      description: "Lista de usuarios de trabajadores de la agencia.",
      show: (
        user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI" || 
        user?.puesto?.toUpperCase() === "RRHH"
      )
    },
    {
      title: "Cumpleaños",
      path: "/home/cumpleanios",
      icon: FaBirthdayCake,
      category: "Administrativo",
      description: "Calendario de cumpleaños de los clientes y trabajadores.",
      show: (
        user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() === "SUPERVISOR CONTROL DE CALIDAD" || 
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "RRHH"
      )
    },
    {
      title: "Estadísticas trabajadores",
      path: "/home/estadisticas-trabajador",
      icon: FaChartBar,
      category: "Administrativo",
      description: "Métricas de seguimiento de los trabajadores (minutos trabajados, tardanzas, pagos, etc.)",
      show: (
        user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI" || 
        user?.puesto?.toUpperCase() === "RRHH"
      )
    },
    {
      title: "Registro de asistencias",
      path: "/home/registro-asistencias-admin",
      icon: FaBook,
      category: "Administrativo",
      description: "Registro de asistencias de los trabajadores.",
      show: (
        user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI" ||
        user?.puesto?.toUpperCase() === "RRHH"
      )
    },
    {
      title: "Incidencias",
      path: "/home/incidencias",
      icon: FaExclamationCircle,
      category: "Administrativo",
      description: "Registro de incidencias de los trabajadores.",
      show: (
        user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI" ||
        user?.puesto?.toUpperCase() === "RRHH"
      )
    },
    {
      title: "Proveedores",
      path: "/home/proveedores",
      icon: FaUsersCog,
      category: "Administrativo",
      description: "Registro de proveedores de la agencia.",
      show: (user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI")
    },
    {
      title: "Inventario",
      path: "/home/inventario",
      icon: FaBox,
      category: "Administrativo",
      description: "Lista de inventario de la agencia.",
      show: user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI"
    },
    {
      title: "Admin correo",
      path: "/home/admin-correo",
      icon: FaEnvelope,
      category: "Administrativo",
      description: "Crear, editar y eliminar cuentas de correo. Gestionar accesos de trabajadores y firmas.",
      show: user?.puesto?.toUpperCase() === "GERENTE GENERAL" 
    },



    // Contabilidad
    {
      title: "Estadística ingresos",
      path: "/home/estadistica-ingresos",
      icon: FaChartPie,
      category: "Contabilidad",
      description: "Múltiples gráficos de los ingresos de la agencia por mes.",
      show: ((user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() === "ADMINISTRADOR") ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL") &&
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Conciliación",
      path: "/home/conciliacion",
      icon: FaChartPie,
      category: "Contabilidad",
      description: "Conciliación de pagos y ventas.",
      show: (user?.area?.toUpperCase() === "ADMINISTRACION" &&
        (user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI") &&
        user?.puesto?.toUpperCase() !== "RRHH"
      )
    },
    {
      title: "Gastos agencia",
      path: "/home/gastos-agencia",
      icon: FaMoneyBill,
      category: "Contabilidad",
      description: "Tabla/calendario de los gastos de la agencia por mes.",
      show: (user?.area?.toUpperCase() === "ADMINISTRACION" &&
        (user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI") &&
        user?.puesto?.toUpperCase() !== "RRHH"
      )
    },
    {
      title: "Pagos trabajadores",
      path: "/home/pagos-trabajadores",
      icon: FaCommentDollar,
      category: "Contabilidad",
      description: "Tabla de los pagos de los trabajadores por mes y año.",
      show: (
        user?.area?.toUpperCase() === "ADMINISTRACION" &&
        (user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI" ||
        user?.puesto?.toUpperCase() === "RRHH")
      )
    },
    {
      title: "Registro de comisiones",
      path: "/home/registro-comisiones",
      icon: FaMoneyBillTrendUp,
      category: "Contabilidad",
      description: "Tabla de las comisiones de las vendedoras según sus ventas, metas y objetivos.",
      show: (user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "RRHH")
    },
    {
      title: "Registro de ventas",
      path: "/home/registro-ventas",
      icon: FaChartBar,
      category: "Contabilidad",
      description: "Lista de pagos.",
      show: (user?.area?.toUpperCase() === "ADMINISTRACION" &&
        (user?.puesto?.toUpperCase() === "JEFE DE PROYECTOS" ||
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI") &&
        user?.puesto?.toUpperCase() !== "RRHH")
    },
    {
      title: "Registro de compras", 
      path: "/home/compras-proveedores",
      icon: FaShoppingCart,
      category: "Contabilidad",
      description: "Listado de compras.",
      show: (user?.area?.toUpperCase() === "ADMINISTRACION" &&
        (user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI") &&
        user?.puesto?.toUpperCase() !== "RRHH")
    },
    {
      title: "Pagos recurrentes",
      path: "/home/pagos-recurrentes",
      icon: FaCloud,
      category: "Contabilidad",
      description: "Suscripciones y gastos mensuales (AWS, GCP, etc.).",
      show: canAccessPagosRecurrentes(user),
    },
    {
      title: "Supuestos de ventas",
      path: "/home/supuestos-ventas",
      icon: FaChartBar,
      category: "Contabilidad",
      description: "Tabla de las ventas supuestos de los clientes por mes y año.",
      show: (user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        user?.puesto?.toUpperCase() !== "RRHH")
    },
    // {
    //   title: "Registro de compras (deprecado)",
    //   path: "/home/registro-compras",
    //   icon: FaShoppingCart,
    //   category: "Contabilidad",
    //   description: "Listado de compras de la agencia (gastos).",
    //   show:
    //     user?.area?.toUpperCase() === "ADMINISTRACION" &&
    //     user?.puesto?.toUpperCase() === "JEFE DE PROYECTOS" ||
    //     user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
    //     user?.puesto?.toUpperCase() === "GERENTE GENERAL"
    // },
    // {
    //   title: "Ventas y pagos",
    //   path: "/home/registro-ventas",
    //   icon: FaChartLine,
    //   category: "Contabilidad",
    //   description: "Tabla de las ventas de los clientes por mes y año.",
    //   show:
    //     user?.puesto?.toUpperCase() === "JEFE DE MARKETING" ||
    //     (
    //       user?.area?.toUpperCase() === "ADMINISTRACION" &&
    //       (
    //         user?.puesto?.toUpperCase() === "JEFE DE PROYECTOS" ||
    //         user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
    //         user?.puesto?.toUpperCase() === "GERENTE GENERAL"
    //       )
    //     )
    // },



    // Cobranzas
    {
      title: "Proyección de ingresos",
      path: "/home/proyeccion-ingresos",
      icon: FaChartLine,
      category: "Cobranzas",
      description: "Proyección de los ingresos de la agencia por mes.",
      show: (user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL"
      ) && user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Renovación H&D",
      path: "/home/renovacionHostingydominios",
      icon: FaCalendarDays,
      category: "Cobranzas",
      description: "Tabla/lista de el cronograma de renovación de los servicios de hosting y dominios de los clientes.",
      show: user?.area?.toUpperCase() === "ADMINISTRACION" && user?.puesto?.toUpperCase() !== "RRHH",
    },
    {
      title: "Ingresos mensuales",
      path: "/home/ingresos-mensuales",
      icon: FaMoneyCheck,
      category: "Cobranzas",
      description: "Tabla de los ingresos de la agencia por servicio, por cliente y por mes.",
      show: (user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL"
      ) && user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Calendario de cobranza",
      path: "/home/calendario-cobranza",
      icon: GiReceiveMoney,
      category: "Cobranzas",
      description: "Calendario de pagos de los clientes en el sistema.",
      show: (
        user?.subarea?.toUpperCase() === "JEFE DE PROYECTOS" ||
        user?.puesto?.toUpperCase() === "JEFE DE PROYECTOS" ||
        user?.puesto?.toUpperCase() === "SUPERVISOR CONTROL DE CALIDAD" ||
        user?.subarea?.toUpperCase() === "POST VENTA" ||
        user?.subarea?.toUpperCase() === "JEFE VENTAS" ||
        user?.subarea?.toUpperCase() === "JEFE DE PROYECTOS" ||
        user?.subarea?.toUpperCase() === "VENTAS" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI"
      ) && user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Historial de deudores",
      path: "/home/historial-deudores",
      icon: FaFileInvoiceDollar,
      category: "Cobranzas",
      description: "Tabla de los clientes con deuda.",
      show: (user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
        user?.puesto?.toUpperCase() === "GESTION ADMI"
      )
    },
    {
      title: "Historial de cancelaciones",
      path: "/home/historial-cancelaciones",
      icon: FaTimesCircle,
      category: "Cobranzas",
      description: "Tabla de los clientes que cancelaron sus contratos con la agencia.",
      show: user?.area?.toUpperCase() === "ADMINISTRACION" && user?.puesto?.toUpperCase() !== "RRHH"
    },



    // Proyectos
    {
      title: "Salida proyectos",
      path: "/home/salidaProyectos",
      icon: FaFolderOpen,
      category: "Proyectos",
      description: "Seguimiento de los servicios de salida de proyectos.",
      show: !isTempSeller(user) && user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        !isTempWorker(user) && !isSEOWorker(user) && user?.puesto?.toUpperCase().trim() !== "ASISTENTE AUDIOVISUALES" && user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Proyectos",
      path: "/home/seguimiento",
      icon: FaClipboardList,
      category: "Proyectos",
      description: "Seguimiento de los clientes y sus servicios (proyectos).",
      show: !isTempSeller(user) && (
        user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        !isTempWorker(user) && 
        !isSEOWorker(user) && (
          user?.area?.toUpperCase() !== "COMERCIAL" || 
          user?.puesto?.toUpperCase() === "JEFE COMERCIAL" || 
          user?.puesto?.toUpperCase() === "JEFE DE MARKETING" ||
          user?.puesto?.toUpperCase() !== "SEO"
        )
      ) && user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Webs",
      path: "/home/proyectosWebs",
      icon: FaWordpress,
      category: "Proyectos",
      description: "Seguimiento de los servicios de webs (Wordpress).",
      show: !isTempSeller(user) && user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        !isTempWorker(user) && !isSEOWorker(user) && user?.puesto?.toUpperCase().trim() !== "ASISTENTE AUDIOVISUALES" && 
        user?.puesto?.toUpperCase() !== "RRHH"
      // show: (
      //   user?.area?.toUpperCase() === "SOFTWARE" ||  
      //   user?.area?.toUpperCase() === "ADMINISTRACION" ||
      //   user?.subarea?.toUpperCase() === "CAMPAÑAS"
      // )
    },
    {
      title: "Soporte Web",
      path: "/home/proyectosSoporteWeb",
      icon: FaWrench,
      category: "Proyectos",
      description: "Seguimiento de los servicios de soporte web.",
      show: !isTempSeller(user) && user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        !isTempWorker(user) && !isSEOWorker(user) && (
        user?.area?.toUpperCase() === "MARKETING" || 
        (user?.area?.toUpperCase() === "ADMINISTRACION" &&
          user?.puesto?.toUpperCase() !== "GESTION ADMI") || 
        (
          user?.area.toUpperCase() === "SOFTWARE" && user?.puesto.toUpperCase() === "DESARROLLADOR FULL STACK" || 
          user?.puesto.toUpperCase() === "DESARROLLADOR DE WORDPRESS Y CMS" || 
          user?.puesto.toUpperCase() === "ASISTENTE DE WORDPRESS Y CMS"
        )
      ) && 
      user?.puesto?.toUpperCase().trim() !== "ASISTENTE AUDIOVISUALES" && 
      user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Software",
      path: "/home/proyectosSoftware",
      icon: FaCode,
      category: "Proyectos",
      description: "Seguimiento de los servicios de software.",
      show: isTempSeller(user) || (
        user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        !isTempWorker(user) && !isSEOWorker(user) && (
        user?.area?.toUpperCase() === "SOFTWARE" ||  
        (user?.area?.toUpperCase() === "ADMINISTRACION" &&
          user?.puesto?.toUpperCase() !== "GESTION ADMI")) && 
        user?.puesto?.toUpperCase().trim() !== "ASISTENTE AUDIOVISUALES" && 
        user?.puesto?.toUpperCase() !== "RRHH")
    },
    {
      title: "SaaS",
      path: "/home/proyectosSaas",
      icon: FaCloud,
      category: "Proyectos",
      description: "Seguimiento de los servicios de SaaS.",
      show: !isTempSeller(user) && user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        !isTempWorker(user) && !isSEOWorker(user) && (
        user?.area?.toUpperCase() === "SOFTWARE" ||  
        (user?.area?.toUpperCase() === "ADMINISTRACION" &&
          user?.puesto?.toUpperCase() !== "GESTION ADMI")) && 
        user?.puesto?.toUpperCase().trim() !== "ASISTENTE AUDIOVISUALES" && 
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "SEO",
      path: "/home/proyectosSEO",
      icon: FaSearch,
      category: "Proyectos",
      description: "Seguimiento de los servicios de SEO.",
      show: !isTempSeller(user) && user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        !isTempWorker(user) && user?.puesto?.toUpperCase().trim() !== "ASISTENTE AUDIOVISUALES" && 
        user?.puesto?.toUpperCase() !== "RRHH"
      // show: (
      //   user?.area?.toUpperCase() === "SOFTWARE" ||  
      //   user?.area?.toUpperCase() === "ADMINISTRACION"
      // )
    },
    {
      title: "UI/UX",
      path: "/home/proyectosUIUX",
      icon: FaPaintRoller,
      category: "Proyectos",
      description: "Seguimiento de los servicios de UI/UX.",
      show: !isTempSeller(user) && user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        !isTempWorker(user) && !isSEOWorker(user) && user?.puesto?.toUpperCase().trim() !== "ASISTENTE AUDIOVISUALES" && 
        user?.puesto?.toUpperCase() !== "RRHH"
      // show: (
      //   user?.area?.toUpperCase() === "SOFTWARE" ||  
      //   user?.area?.toUpperCase() === "ADMINISTRACION"
      // )
    },
    {
      title: "Ads",
      path: "/home/proyectosAds",
      icon: MdCampaign,
      category: "Proyectos",
      description: "Seguimiento de los servicios de campañas.",
      show: !isTempSeller(user) && user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        !isTempWorker(user) && !isSEOWorker(user) && user?.puesto?.toUpperCase().trim() !== "ASISTENTE AUDIOVISUALES" && 
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "SMM",
      path: "/home/proyectosSmm",
      icon: FaComments,
      category: "Proyectos",
      description: "Seguimiento de los servicios de social media manager.",
      show: !isTempSeller(user) && user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        (isTempWorker(user) ? isSEOWorker(user) ? false : isTempMarketing(user) : !isSEOWorker(user)) && 
        user?.puesto?.toUpperCase() !== "RRHH",
      // show: (
      //   user?.area?.toUpperCase() === "MARKETING" ||  
      //   user?.area?.toUpperCase() === "ADMINISTRACION"
      // )
    },
    {
      title: "Branding",
      path: "/home/proyectosBranding",
      icon: FaPalette,
      category: "Proyectos",
      description: "Seguimiento de los servicios de branding.",
      show: !isTempSeller(user) && user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        !isTempWorker(user) && !isSEOWorker(user) && 
        user?.puesto?.toUpperCase() !== "RRHH",
      // show: (
      //   user?.area?.toUpperCase() === "MARKETING" ||  
      //   user?.area?.toUpperCase() === "ADMINISTRACION"
      // )
    },
    {
      title: "Otros",
      path: "/home/proyectosOtros",
      icon: FaGlobe,
      category: "Proyectos",
      show: !isTempSeller(user) && user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        !isTempWorker(user) && !isSEOWorker(user) && 
        user?.puesto?.toUpperCase() !== "RRHH",
      // show: (
      //   user?.area?.toUpperCase() === "MARKETING" ||  
      //   user?.area?.toUpperCase() === "ADMINISTRACION"
      // )
    },
    {
      title: "Audiovisuales",
      path: "/home/proyectosAudiovisuales",
      icon: FaCamera,
      category: "Proyectos",
      description: "Seguimiento de los servicios de audiovisuales.",
      show: !isTempSeller(user) && user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        (isTempWorker(user) ? isSEOWorker(user) ? false : isTempAudiovisual(user) : !isSEOWorker(user)) && 
        user?.puesto?.toUpperCase() !== "RRHH",
      // show: (
      //   user?.area?.toUpperCase() === "MARKETING" || 
      //   user?.area?.toUpperCase() === "ADMINISTRACION"
      // )
    },
    {
      title: "Hosting y dominios",
      path: "/home/proyectosHostingDominios",
      icon: FaGlobe,
      category: "Proyectos",
      description: "Seguimiento de los servicios de hosting y dominios.",
      show: !isTempSeller(user) && user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI" && 
        user?.puesto?.toUpperCase() !== "RRHH"
      // (
      //   user?.area?.toUpperCase() === "MARKETING" || 
      //   user?.area?.toUpperCase() === "ADMINISTRACION" || 
      //   (
      //     user?.area.toUpperCase() === "SOFTWARE" && (
      //       user?.puesto.toUpperCase() === "DESARROLLADOR FULL STACK" || 
      //       user?.puesto.toUpperCase() === "DESARROLLADOR DE WORDPRESS Y CMS" || 
      //       user?.puesto.toUpperCase() === "ASISTENTE DE WORDPRESS Y CMS"
      //     )
      //   )
      // ) && 
      // user?.puesto?.toUpperCase().trim() !== "ASISTENTE AUDIOVISUALES"
    },




    // Operativa
    {
      title: "Integración proyectos",
      path: "/home/integracion-proyectos",
      icon: FaFolderOpen,
      category: "Operativa",
      description: "Integración de proyectos.",
      show: user?.puesto?.toUpperCase() !== "GESTION ADMI" && 
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Calendario de citas",
      path: "/home/calendario-citas",
      icon: MdCalendarMonth,
      category: "Operativa",
      description: "Calendario de citas de el área operativa con los clientes.",
      show: (
        user?.area?.toUpperCase() === "ADMINISTRACION" || 
        user?.area?.toUpperCase() === "SOFTWARE" ||
        user?.area?.toUpperCase() === "MARKETING"
      ) && user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Tareas",
      path: "/home/tareas",
      icon: FaListUl,
      category: "Operativa",
      description: "Tus tareas dejadas por administración.",
      show: user?.puesto?.toUpperCase() !== "GESTION ADMI" && 
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Encuestas",
      path: "/home/plantillasEncuestas",
      icon: FaPoll,
      category: "Operativa",
      description: "Plantillas de encuestas y respuestas de encuestas resueltas.",
      show: (user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI" && 
        user?.puesto?.toUpperCase() !== "RRHH")
    },
        // {
    //   title: "Ventas proyectos",
    //   path: "/home/ventas-proyectos",
    //   icon: FaFolderOpen,
    //   category: "Operativa",
    //   description: "Listado de proyectos vendidos que requieren una producción audiovisual para marketing de la agencia.",
    //   show: (
    //     user?.area?.toUpperCase() === "ADMINISTRACION" || 
    //     user?.area?.toUpperCase() === "COMERCIAL"
    //   )
    // },
    // {
    //   title: "Operativa proyectos",
    //   path: "/home/operativa-proyectos",
    //   icon: FaFolderOpen,
    //   category: "Operativa",
    //   show: (
    //     user?.area?.toUpperCase() === "ADMINISTRACION" || 
    //     user?.area?.toUpperCase() === "SOFTWARE" ||
    //     user?.area?.toUpperCase() === "MARKETING"
    //   )
    // },
    // {
    //   title: "Audiovisual proyectos",
    //   path: "/home/audiovisual-proyectos",
    //   icon: FaFolderOpen,
    //   category: "Operativa",
    //   show: (
    //     user?.area?.toUpperCase() === "ADMINISTRACION" || 
    //     (user?.area?.toUpperCase() === "MARKETING" && user?.subarea?.toUpperCase() === "AUDIOVISUALES") ||
    //     (user?.area?.toUpperCase() === "MARKETING" && user?.subarea?.toUpperCase() === "SOCIAL MEDIA")
    //   )
    // },



    // Clientes
    {
      title: "Tickets",
      path: "/home/tickets",
      icon: FaTicket,
      category: "Clientes",
      description: "Listado de tickets de los clientes.",
      show: true
    },
    {
      title: "Calendario revisiones servicios",
      path: "/home/calendarioRevisiones",
      icon: FaCalendarCheck,
      category: "Clientes",
      description: "Calendario de revisiones de los servicios de los clientes.",
      show: !isTempSeller(user) && user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI" && user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Redes clientes",
      path: "/home/redes-clientes",
      icon: FiShare2,
      category: "Clientes",
      description: "Listado de los clientes y sus servicios adquiridos, junto con los links relevantes.",
      show: !isTempSeller(user) && !isSEOWorker(user) && (
        user?.area?.toUpperCase() === "COMERCIAL" ||
        (user?.area?.toUpperCase() === "ADMINISTRACION" &&
          user?.puesto?.toUpperCase() !== "GESTION ADMI") ||
        user?.puesto?.toUpperCase() === "JEFE DE MARKETING" 
      ) && user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Redes clientes Webs",
      path: "/home/redes-clientes-webs",
      icon: FaNetworkWired,
      category: "Clientes",
      description: "Listado de los clientes que adquirieron servicios webs, junto con los links relevantes de cada proyecto.",
      show: !isTempWorker(user) && !isSEOWorker(user) && (
        (user?.area?.toUpperCase() === "ADMINISTRACION" &&
          user?.puesto?.toUpperCase() !== "GESTION ADMI") ||
        user?.area?.toUpperCase() === "SOFTWARE" || 
        user?.area?.toUpperCase() === "COMERCIAL" ||
        user?.puesto?.toUpperCase() === "JEFE DE MARKETING"
      ) && user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Redes clientes ads",
      path: "/home/redes-clientes-ads",
      icon: FaAd,
      category: "Clientes",
      description: "Listado de los clientes que adquirieron servicios de campañas, junto con los links relevantes de cada proyecto.",
      show: (
      (user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI") ||
      user?.area?.toUpperCase() === "MARKETING" || 
      user?.area?.toUpperCase() === "COMERCIAL" ||
      user?.puesto?.toUpperCase() === "JEFE DE MARKETING"
      ) && user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Afiliación clientes",
      path: "/home/afiliacion-clientes",
      icon: FaUserEdit,
      category: "Clientes",
      description: "Listado de los clientes e información relevante, junto con sus servicios y cotizaciones.",
      show: !isTempSeller(user) && (
        user?.area?.toUpperCase() === "COMERCIAL" && 
        (user?.puesto?.toUpperCase() === "EJECUTIVO DE CUENTAS" ||
        user?.puesto?.toUpperCase() === "JEFE COMERCIAL")
      ) || (
        user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI" &&
        (user?.puesto?.toUpperCase() === "ASISTENTE" ||
        user?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
        user?.puesto?.toUpperCase() === "SUPERVISOR CONTROL DE CALIDAD" ||
        user?.puesto?.toUpperCase() === "GERENTE GENERAL")
      ) || (
        user?.puesto?.toUpperCase() === "JEFE DE MARKETING"
      ) && user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Registro llamadas",
      path: "/home/registroLlamadas",
      icon: FaPhone,
      category: "Clientes",
      description: "Registro de llamadas de los trabajadores a través del teléfono en el sistema.",
      show: !isTempSeller(user) && user?.area?.toUpperCase() !== "COMERCIAL" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI"
    },
    // {
    //   title: "Registro llamadas manuales",
    //   path: "/home/registroLlamadasManuales",
    //   icon: FaPhoneAlt,
    //   category: "Clientes",
    //   description: "Registro de llamadas de los trabajadores a través del teléfono en el sistema.",
    //   show: user?.area?.toUpperCase() !== "COMERCIAL"
    // },



    // Comercial
    {
      title: "Reglas de comisionees",
      path: "/home/reglas-comisiones",
      icon: FaMoneyBillTrendUp,
      category: "Comercial",
      description: "Tabla de reglas de comisiones.",
      show: user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI" && 
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Cotizaciones",
      path: "/home/cotizaciones",
      icon: FaMoneyCheckAlt,
      category: "Comercial",
      description: "Tabla de cotizaciones.",
      show: (user?.area?.toUpperCase() === "COMERCIAL" ||
        user?.area?.toUpperCase() === "VENTAS" ||
        user?.puesto?.toUpperCase() === "JEFE DE MARKETING" || 
        user?.area?.toUpperCase() === "ADMINISTRACION") &&
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Precios y promociones",
      path: "/home/precios-y-promociones",
      category: "Comercial",
      icon: FaTag,
      description: "Tabla de precios y promociones de los servicios, por plan y país.",
      show: (user?.area?.toUpperCase() === "COMERCIAL" ||  
        (user?.area?.toUpperCase() === "ADMINISTRACION" &&
          user?.puesto?.toUpperCase() !== "GESTION ADMI") || 
        user?.puesto?.toUpperCase() === "JEFE DE MARKETING") &&
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Solicitudes Post Venta",
      path: "/home/solicitudes-post-venta",
      category: "Comercial",
      icon: FaFileAlt,
      description: "Tabla de solicitudes de post venta.",
      show: ((user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI") ||  
        user?.area?.toUpperCase() === "COMERCIAL") &&
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Calendario cotizaciones",
      path: "/home/calendario-cotizaciones",
      icon: FaCalendarDays,
      category: "Comercial",
      description: "Calendario de cotizaciones.",
      show: user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI" && 
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Actividad trackeo de leads",
      path: "/home/dashboardActividadesComercialHora",
      icon: FaClock,
      category: "Comercial",
      description: "Gráficas de la actividad de los vendedores.",
      show: ((user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI") || 
        user?.area?.toUpperCase() === "COMERCIAL" || 
        user?.puesto?.toUpperCase() === "JEFE DE MARKETING") &&
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Historial de leads",
      path: "/home/trackeoLeads",
      category: "Comercial",
      icon: FaUser,
      description: "Lista de leads y prospectos.",
      show: ((user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI") || 
        user?.area?.toUpperCase() === "COMERCIAL" || 
        user?.puesto?.toUpperCase() === "JEFE DE MARKETING") &&
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Funnel de leads",
      path: "/home/funnelLeads",
      category: "Comercial",
      icon: FaFilter,
      description: "Funnel de leads.",
      show: ((user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI") || 
        user?.area?.toUpperCase() === "COMERCIAL" || 
        user?.puesto?.toUpperCase() === "JEFE DE MARKETING") &&
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Calendario de eventos de leads",
      path: "/home/calendarioEventosLeads",
      category: "Comercial",
      icon: FaCalendar,
      description: "Calendario de eventos de leads.",
      show: ((user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI") || 
        user?.area?.toUpperCase() === "COMERCIAL" || 
        user?.puesto?.toUpperCase() === "JEFE DE MARKETING") &&
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Trazabilidad de leads individual",
      path: "/home/dashboardActividadesComercial",
      icon: FaRegCalendarDays,
      category: "Comercial",
      description: "Tabla de trazabilidad de los eventos de los leads.",
      show: ((user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI") || 
        user?.area?.toUpperCase() === "COMERCIAL") &&
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Trazabilidad de leads",
      path: "/home/dashboardLeads",
      icon: FaChartBar,
      category: "Comercial",
      description: "Tabla detallada de trazabilidad de los eventos de los leads y los KPIs de los miembros del área comercial.",
      show: ((user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI") || 
        user?.area?.toUpperCase() === "COMERCIAL") &&
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    {
      title: "Tabla comparativa de leads",
      path: "/home/dashboardLeadsDia",
      icon: FaCalendarCheck,
      category: "Comercial",
      description: "Tabla comparativa de los eventos de cada vendedor, por día.",
      show: ((user?.area?.toUpperCase() === "ADMINISTRACION" &&
        user?.puesto?.toUpperCase() !== "GESTION ADMI") || 
        user?.area?.toUpperCase() === "COMERCIAL") &&
        user?.puesto?.toUpperCase() !== "RRHH"
    },
    // {
    //   title: "Formularios",
    //   path: "/home/formularios",
    //   icon: FaWpforms,
    //   show: (
    //     user?.area?.toUpperCase() === "ADMINISTRACION" &&
    //     user?.puesto?.toUpperCase() === "ASISTENTE" || 
    //     user?.puesto?.toUpperCase() === "JEFE DE PROYECTOS" || 
    //     user?.puesto?.toUpperCase() === "GERENTE GENERAL"
    //   )
    // },
  ];

  const [openCategory, setOpenCategory] = useState(null);
  const [categorySelected, setCategorySelected] = useState("")
  const [buttonSelected, setButtonSelected] = useState("")

  const navigate = useNavigate(); // Hook para cambiar de ruta sin recargar
  const location = useLocation(); // Obtiene la ruta actual

  const handleToggle = (category) => {
    if (openCategory === category) {
      setOpenCategory(null); // Cierra el menú
      setCategorySelected(""); // Deselecciona la categoría
    } else {
      setOpenCategory(category); // Abre el menú
      setCategorySelected(category); // Marca la categoría seleccionada
    }
    setButtonSelected(""); // Reinicia la selección de botones
  };

  const handleItemClick = (itemTitle, path) => {
    setButtonSelected(itemTitle); // Marca el botón seleccionado
    navigate(path); // Navega a la nueva ruta sin recargar la página

  };

  const categories = [
    {name: "Administrativo", icon: AdminPanelSettingsIcon},
    {name: "Contabilidad", icon: AccountBalanceIcon},
    {name: "Cobranzas", icon: FaMoneyBillTrendUp},
    {name: "Proyectos", icon: AssignmentIcon},
    {name: "Operativa", icon: ConstructionIcon},
    {name: "Clientes", icon: FaUsers},
    {name: "Comercial", icon: BusinessCenterIcon}, 
  ]

  const categoriesGroup = categories.map((c) => ({ // Botones con categoría
    icon: c.icon,
    category: c.name,
    items: items.filter((i) => i.category === c.name && i.show) // Botones independientes, sin cartegoría
  }));

  const independantButtons = items.filter((i) => !i.category)
  return (
    <div>
      <List
        sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        {independantButtons.map((b, i) => (
          <ListItemButton 
            key={i}
            onClick={() => {
              handleItemClick(b.title, b.path)
              setCategorySelected("")
            }}
            onMouseDown={(event) => {
              if (event.button === 1) { // Middle click
                window.open(b.path, '_blank');
                event.preventDefault(); // Evita que se active el evento onClick
              }
            }}
            selected={buttonSelected === b.title}
            sx={{
              borderRadius: "8px",
              '&.Mui-selected': { 
                backgroundColor: "#ffccaa",
                color: "#000",
                fontWeight: "bold",
              },
              '&.Mui-selected:hover': { 
                backgroundColor: "#ffbb99",
              },
              '&:hover': {
                backgroundColor: "#ffe6d7",
              }
            }}
          >
            <ListItemIcon>
              <b.icon />
            </ListItemIcon>
            <ListItemText 
              primary={b.title}
              primaryTypographyProps={{
                fontWeight: 'medium',
                fontFamily: "Poppins",
                fontSize: "small",
                color: "#5b5b5b"
              }}
            />
            {i === 0 && 
              notifications > 0 && (
                <Tooltip content="Notificaciones">
                  <div className="flex items-center justify-center relative">
                    <div className="absolute -top-1 -right-1 bg-black text-white rounded-full w-5 h-5 flex items-center justify-center text-[xs] font-medium">
                      {notifications}
                    </div>
                    <FaBell className="text-red-500 text-2xl" />
                  </div>
                </Tooltip>
              )
            }
          </ListItemButton>
        ))}

        {categoriesGroup.filter((c) => c.items.length > 0).map((c) => (
          <React.Fragment key={c.category}>
            <ListItemButton 
              onClick={() => handleToggle(c.category)}
              selected={categorySelected === c.category}
              sx={{
                borderRadius: "8px",
                '&.Mui-selected': { 
                  backgroundColor: "#ffccaa",
                  color: "#000",
                  fontWeight: "bold",
                },
                '&.Mui-selected:hover': { 
                  backgroundColor: "#ffbb99",
                },
                '&:hover': {
                  backgroundColor: "#ffe6d7",
                }
              }}
            >
              <ListItemIcon>
                <c.icon />
              </ListItemIcon>
              <ListItemText 
                primary={c.category} 
                primaryTypographyProps={{
                  fontWeight: 'medium',
                  fontFamily: "Poppins",
                  fontSize: "small",
                  color: "#5b5b5b"
                }}
              />
              {openCategory === c.category ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openCategory === c.category} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {c.items.map((item) => (
                  <ListItemButton 
                    key={item.title} 
                    sx={{ 
                      pl: 5,
                      borderRadius: "8px",
                      '&.Mui-selected': {backgroundColor: "#e6e6e6"},
                      '&.Mui-selected:hover': {backgroundColor: "#d6d6d6"},
                      '&:hover': {backgroundColor: "#f1f1f1"}
                    }}
                    onMouseDown={(event) => {
                      if (event.button === 1) { // Middle click
                        window.open(item.path, '_blank');
                        event.preventDefault(); // Evita que se active el evento onClick
                      }
                    }}
                    onClick={() => handleItemClick(item.title, item.path)}
                    selected={buttonSelected === item.title}
                  >
                    <ListItemIcon>
                      <item.icon />
                    </ListItemIcon>
                    <ListItemText 
                      primary={item.title} 
                      primaryTypographyProps={{
                        fontWeight: 'medium',
                        fontFamily: "Poppins",
                        fontSize: "small",
                        color: "#5b5b5b"
                      }}
                    />
                    {item.description && (
                      <Tooltip content={item.description}>
                        <div className="flex items-center justify-center ml-4">
                          <FaInfoCircle className="text-gray-400 hover:text-blue-500 transition-colors duration-200 text-xs" />
                        </div>
                      </Tooltip>
                    )}
                  </ListItemButton>
                ))}
              </List>
            </Collapse>
          </React.Fragment>
        ))}
      </List>
    </div>
  );
};

export default NavConfig;
function NavItem({ item, collapsed, upLg }) {
  const pathname = usePathname();

  const active = item.path === pathname;
  

  return (
    <ListItemButton
      component={RouterLink}
      href={item.path}
      className="flex justify-start  gap-4 items-center "
      sx={{
        minHeight: 44,
        borderRadius: 0.75,
        typography: "body2",
        color: "text.secondary",
        textTransform: "capitalize",
        ...(active && {
          color: "#FF6400",
          bgcolor: (theme) => alpha("#FF6400", 0.08),
          "&:hover": {
            bgcolor: (theme) => alpha("#FF6400", 0.16),
          },
        }),
      }}
    >
      <div>
        {
          <item.icon
            className={` ${!active ? " text-gray-500 " : ""}  w-5 h-5  `}
          />
        }
      </div>

      {upLg ? (
        <>
          {" "}
          {!collapsed && (
            <div className=" font-semibold text-sm"> {item.title} </div>
          )}
        </>
      ) : (
        <div className=" font-semibold text-sm"> {item.title} </div>
      )}
    </ListItemButton>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
};
